module.exports = __webpack_public_path__ + "img/ceyicehuodong.2a0edb61.png";